// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/(app)/dashboard": [6,[2]],
		"/(app)/dashboard/create": [7,[2]],
		"/(app)/dashboard/settle": [8,[2]],
		"/(app)/join": [9,[2]],
		"/(app)/ledger/[ledgerId]": [10,[2,3]],
		"/(app)/ledger/[ledgerId]/audit": [11,[2,3]],
		"/(app)/ledger/[ledgerId]/balances": [12,[2,3]],
		"/(app)/ledger/[ledgerId]/invite": [13,[2,3]],
		"/(app)/ledger/[ledgerId]/lobby": [14,[2,3]],
		"/(app)/ledger/[ledgerId]/settings": [15,[2,3]],
		"/(app)/ledger/[ledgerId]/settings/participants/[participantId]": [16,[2,3]],
		"/(app)/ledger/[ledgerId]/transactions": [17,[2,3]],
		"/(app)/ledger/[ledgerId]/transactions/[transactionId]": [18,[2,3]],
		"/(auth)/login": [22,[4]],
		"/(app)/notifications": [19,[2]],
		"/(app)/profile": [20,[2]],
		"/(auth)/register": [23,[4]],
		"/(app)/setup-handle": [21,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);